import * as angular from 'angular';

import template from './rename-modal.html';

const renameModalDirective = function (Modal, $sce: angular.ISCEService) {
  return {
    restrict: 'A',

    link: function ($scope: any, $elem) {
      $elem.on('click.rename', (event) => {
        event.preventDefault();
        const newName = { name: $scope.renameModal };

        const modal = Modal.open(
          {
            model: newName,
            title: $scope.renameModalTitle,
            confirmText: $scope.confirmModalButtonConfirm,
            cancelText: $scope.confirmModalButtonCancel,
            confirmButtonClass: $scope.confirmModalButtonClass,
          },
          {
            template: template,
          }
        );

        modal.result.then(() => $scope.renameModalOnConfirm({ $value: newName.name })).catch(function () {});
      });

      // cleanup handlers
      $scope.$on('$destroy', () => $elem.off('click.rename'));
    },

    scope: {
      renameModal: '<',
      renameModalTitle: '@',
      renameModalOnConfirm: '&',
      confirmModalButtonConfirm: '@?',
      confirmModalButtonCancel: '@?',
      confirmModalButtonClass: '@?',
    },
  };
};

renameModalDirective.$inject = ['ModalService', '$sce'];

angular.module('mode.components').directive('renameModal', renameModalDirective);
